'use client';

import Script from 'next/script';
import { GDPR } from '@/components/GDPR';
import { useSiteContext } from '@/context/SiteContext';
import { camelCaseToKebab } from '@/utils/camel-case-to-kebab';
import React, { useRef, type FC, useEffect, type ReactNode } from 'react';

import './sportsRadar.css';

type SportsRadarProps = {
	widgetName: string;
};

export const SportsRadarWidget: FC<SportsRadarProps> = ({ ...props }) => {
	const containerRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		if (!containerRef.current || containerRef.current.children.length === 1)
			return;

		// Create widget div
		const widgetDiv = document.createElement('div');
		widgetDiv.className = `sr-widget-${Math.floor(Math.random() * 10 ** 4)}`;

		// Format the widget div properties to be set with the
		// 'data-sr-' prefix to allow the sports radar script
		// to correctly form the intended widget
		camelCaseToKebab(widgetDiv, props);

		containerRef.current.appendChild(widgetDiv);
	}, [props]);

	return (
		<div className="sports-widgets">
			<div ref={containerRef} />
		</div>
	);
};

export const SportRadarScriptWrapper = (): ReactNode => {
	const { config } = useSiteContext();
	if (!config?.affiliateVendors?.providers?.Sportradar?.clientId) {
		return null;
	}

	const clientID = config?.affiliateVendors?.providers?.Sportradar?.clientId;

	const scriptSrc = `https://widgets.media.sportradar.com/${clientID}/widgetloader`;
	return (
		<GDPR purposes={['content']} vendorId="sportradar">
			<Script
				async
				data-sr-language="en_us"
				src={scriptSrc}
				type="application/javascript"
			/>
		</GDPR>
	);
};
